import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import "../../coursepages/AvailabilitySettings.css";
import "./ModuleSettings.css";

const ModuleSettings = ({
  isOpen,
  onClose,
  showCategories,
  onToggleCategories,
  hasAIAccess,
  isQuizMode,
  onModeToggle,
  AIChatEnabled,
  onAIChatToggle,
}) => {
  if (!isOpen) return null;

  const handleToggleClick = () => {
    if (!hasAIAccess) {
      alert(
        "Please upgrade to TeacherPlus to access AI categorization features."
      );
      return;
    }
    onToggleCategories();
  };

  return (
    <div className="availability-modal">
      <div className="availability-content">
        <h2>Module Settings</h2>
        <button className="close-button" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <div className="settings-section">
          <div className="setting-item">
            <span className="setting-label">Module Mode (Practice/Quiz)</span>
            <label className="mode-toggle-switch">
              <input
                type="checkbox"
                checked={isQuizMode}
                onChange={onModeToggle}
              />
              <span className="mode-toggle-slider">
                <span className="mode-toggle-letter">
                  {isQuizMode ? "Q" : "P"}
                </span>
              </span>
            </label>
          </div>

          <div className="setting-item">
            <span className="setting-label">
              Enable AI Chat for students
              {isQuizMode && (
                <span className="mode-hint">(Disabled in Quiz Mode)</span>
              )}
            </span>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={AIChatEnabled}
                onChange={onAIChatToggle}
                disabled={isQuizMode}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>

          <div className="setting-item">
            <span
              className={`setting-label ${!hasAIAccess ? "disabled" : ""}`}
              title={
                !hasAIAccess
                  ? "Upgrade to TeacherPlus to access AI features"
                  : ""
              }
            >
              Enable Question Tags
              {!hasAIAccess && (
                <span className="upgrade-badge-small">Plus</span>
              )}
            </span>
            <label
              className={`toggle-switch ${!hasAIAccess ? "disabled" : ""}`}
            >
              <input
                type="checkbox"
                checked={showCategories}
                onChange={handleToggleClick}
                disabled={!hasAIAccess}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModuleSettings;
